/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  auth: {
    domain: "portalclientes-auth0.bd.com",
    clientId: "h2ybsF9So7fWgcOyWMK5FtdYa5ywF5WV",
    audience: 'https://nexola.bd.com/',
    serverUrl: 'https://nexola.bd.com/',
    redirectUri: 'https://nexola.bd.com/#/pages/dashboard',
    httpInterceptor: {
      allowedList: ['https://nexola.bd.com/api/*'],
    },
  },
  apiEndPoint: 'https://nexola.bd.com/',
  logInOut: 'https://nexola.bd.com/#/bienvenido',
  activacionUsuario: 'https://nexola.bd.com/#/activar-usuario',
};
